import { observer } from "mobx-react-lite";
import {useContext, useEffect, useState} from "react";
import { NotificationContainer } from 'react-notifications';
import SideNav from "../components/SideNav";
import SingleChat from "../components/PrivateChat";
import { useStore } from "../store";
import Modal from "../components/modal/CustomModal";
import General from "../container/General";
import SOCKET from "../const/socketNames"
import { AnswerCall } from "../components/modal/AnswerCall";
import User from "../states/User";
import { useNavigate } from "react-router-dom";
import {popUp} from "../utils/helpers";
import { Provider} from "react-redux"
import { SocketContext } from "../const/socket.js";
import {  BACKEND_URL } from "../const/Constants";
import avatarImage from "../assets/images/user_avatar.png";
import { langContext } from "../App";
import { langGeneral } from "../container/generalTranslate";
import "./homepage.css"
import UserModal from "../components/modal/UserModal";
import Profile from "../container/Profile";
import {store} from "../components/store/index.ts"
import FileUploadPeer from "../components/FileUploadPeer.tsx";
import { displayName } from "../utils/displayName";
import { uploadPeer } from "../components/fileUploadPeerTranslate";

const Home = observer(({change}) => {
    const lang = useContext(langContext)
    let showBySelected = langGeneral[lang]

    const [navbar, setNavbar] = useState("")
    const [purpose, setPurpose] = useState("create")
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [userModal, setUserModal]=useState(false)

    const [roomId, setRoomId] = useState("")
    const [name, setName] = useState("")
    const [isOpen, setIsOpen] = useState(false);
    const [closeMessagesModal, setCloseMessagesModal] = useState(false)
    const [groupChatOpened, setGroupChatOpened] = useState(false)
    const [searchInput,setSearchInput] = useState("")
    const [pageSelection, setPageSelection] = useState("invite")
    const [selected, setSelected] = useState("")
    const [fromP2P, setFromP2P] = useState(false)
    // incoming peer-to-peer file transfer request waiting for this user's answer
    const [p2pRequest, setP2PRequest] = useState(null)
    const p2pText = uploadPeer[lang] || uploadPeer.arm
    const navigate = useNavigate()
    const socket = useContext(SocketContext)

    const {usersStore, userStore,chatStore, videoRoomStore} = useStore()

    useEffect(function () {
        if(userStore.role === "Guest") {
            userStore.logout()
            navigate("/")
        }else {
            socket.emit(SOCKET.JOIN_CONNECTED, userStore.user)
            if(!window.localStorage.getItem("existRoom")) {
                videoRoomStore.deleteMyOnlineStatus()
            }
            usersStore.getUsers();
        }
    }, [])

    useEffect(() => {
        socket.on(SOCKET.LOGOUT_FIRST_ENTER, () => {
        userStore.logout(true)
        navigate("/")
       })
    }, [socket])
 

    useEffect(function () {
        socket.on(SOCKET.PAGE_REFRESH, () => {
            window.location.reload();
        });
        socket.on(SOCKET.PRIVATE_CALL_WAIT, ({name, room_id}) => {
            userStore.setReceivedCall(true)
            setRoomId(room_id)
            setName(name)
            openModal()
            window.ReactNativeWebView?.postMessage(
                JSON.stringify({
                event: "call",
                data: name
                })
            );
        })

        socket.on(SOCKET.SHUT_DOWN_CALL, () => {
            setIsOpen(false)
            window.location.reload();
        })

        return () =>
        {
            socket.off(SOCKET.PRIVATE_CALL_WAIT)
            socket.off(SOCKET.SHUT_DOWN_CALL)
            socket.off(SOCKET.PAGE_REFRESH)
        }
    },[])

    useEffect(() => {
        let expire
        socket.on(SOCKET.P2P_INCOMING, ({from, fromName}) => {
            clearTimeout(expire)
            setP2PRequest({from, fromName})
            // the sender gives up after a minute, so the prompt does too
            expire = setTimeout(() => setP2PRequest(null), 60000)
        })
        socket.on(SOCKET.P2P_CANCELLED, ({from}) => {
            setP2PRequest(current => current && current.from === from ? null : current)
        })
        return () => {
            clearTimeout(expire)
            socket.off(SOCKET.P2P_INCOMING)
            socket.off(SOCKET.P2P_CANCELLED)
        }
    }, [])

    const acceptP2PRequest = () => {
        // the transfer panel opens in "accept" mode and tells the sender once it is ready
        chatStore.setUsername(p2pRequest.from)
        setFromP2P(true)
        setP2PRequest(null)
    }

    const declineP2PRequest = () => {
        socket.emit(SOCKET.P2P_DECLINE, {to: p2pRequest.from})
        setP2PRequest(null)
    }

    function openModalPurpose(info) {
        setPurpose(info)

        setModalIsOpen(true);
    }

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        socket.emit(SOCKET.APPROVE_OR_CANCEL_PRIVATE_CALL, "cancel", name, User.username)
        socket.emit(SOCKET.SHUT_DOWN_CALL, name, User.username)
        setIsOpen(false);
    }

    const answerCall = () => {
        socket.emit(SOCKET.APPROVE_OR_CANCEL_PRIVATE_CALL, "approve", name , userStore.username)
        setIsOpen(false)
        popUp(`/video-room/${roomId}`)
    }

    const chatHandleClick = () => {
        if (chatStore.username !== 'ALL'){
            socket.emit(SOCKET.CHAT_CLOSE, { username: userStore.username, guestUsername: chatStore.username })
            chatStore.clearUsername()
            chatStore.clearMessages()
            chatStore.setUsername('ALL')
        }
    }

    const avatarImg = userStore.imagePath ? `${BACKEND_URL}${userStore.imagePath}` : avatarImage

    return (
        <>
            <div className="main-div" onClick={() => setCloseMessagesModal(!closeMessagesModal)}>
                <div className="user-navbar">
                    <span className="fontstyles titeles" style={{marginLeft : "24px"}}>{showBySelected.tr_users}</span>
                    <div className='display-right'>                    
                        <button onClick={() => chatHandleClick()} className="button fontstyles" title={showBySelected.tr_myMails}><img  src="/mymsg.png" className="navbar-btn-icon" style={{"width": "15px", "height":"15px", borderRadius: "0",marginRight:"5px"}}/><span className="navbar-btn-label">{showBySelected.tr_myMails}</span></button>
                        <button onClick={() => {usersStore.getUsers(''); setTimeout(() => openModalPurpose("chat"), 50); setGroupChatOpened(!groupChatOpened); setSearchInput("")}} className="button fontstyles" title={showBySelected.tr_groupMails}><img src="/shapegroup.png" className="navbar-btn-icon" style={{"width": "13px", "height":"13px",marginRight:"5px"}}/><span className="navbar-btn-label">{showBySelected.tr_groupMails}</span></button>
                        <div className='user-img-and-name' onClick={() => setUserModal(!userModal)}>
                            <img
                                src={userStore.imagePath ? `${BACKEND_URL}${userStore.imagePath}` : avatarImage}
                                className=" "
                                alt="Avatar" />
                            <p className="fontstyles titeles navbar-user-name" style={{"cursor":"pointer"}}>
                            {displayName(userStore.userData)}</p>
                        </div >
                        {
                            userModal && <UserModal setNavbar={setNavbar} setUserModal={setUserModal}/>
                        }
                    </div>              
                </div>
                <div className="flex">
                    <SideNav setSelected={setSelected} searchInput={searchInput} setSearchInput={setSearchInput} groupChatOpened={groupChatOpened} closeMessagesModal={closeMessagesModal} setCloseMessagesModal={setCloseMessagesModal}/>
                    <General searchInput={searchInput} setSearchInput={setSearchInput} groupChatOpened={groupChatOpened} setGroupChatOpened={setGroupChatOpened} setNavbar={setNavbar} change={change} navbar={navbar} setPurpose={setPurpose} openModal={openModalPurpose} purpose={purpose} modalIsOpen={modalIsOpen} setIsOpen={setModalIsOpen}/>
                 </div>

                {userStore.receivingCall ? (
                    <Modal
                        isOpen={isOpen}
                        isClose={closeModal}
                    >
                        <AnswerCall answerCall={answerCall} closeModal={closeModal} name={name}/>
                    </Modal>
                ) : null}

               {chatStore.username && <SingleChat selected={selected} fromP2P={fromP2P} setFromP2P={setFromP2P}/>}
                <NotificationContainer />
            </div>
            
            <div className="mob-main-div">
                <div className="user-navbar">
                    <span className="fontstyles titeles button" style={{marginLeft : "14px", width: "auto"}} 
                            onClick={()=> pageSelection === "invite" ? 
                            (() => {setPageSelection("users"); setNavbar("")})() : 
                            (() => {setPageSelection("invite"); setNavbar("")})()}>{pageSelection === "invite" ? showBySelected.tr_invites : showBySelected.tr_users}
                    </span>
                    <div className='display-right'>                    
                            <button onClick={() => chatHandleClick()} className="button fontstyles"><img  src="/mymsg.png" style={{"width": "12px", "height":"12px",borderRadius: "0"}}/></button>
                            <button onClick={() => {usersStore.getUsers(''); setTimeout(() => openModalPurpose("chat"), 50); setGroupChatOpened(!groupChatOpened); setSearchInput("")}} className="button fontstyles" style={{marginRight:"10px"}}><img src="/shapegroup.png" style={{"width": "12px", "height":"12px"}}/></button>
                            <div className='user-img-and-name' onClick={() => setUserModal(!userModal)}>
                                <img
                                    src={userStore.imagePath ? `${BACKEND_URL}${userStore.imagePath}` : avatarImage}
                                    className=" "
                                    alt="Avatar" />
                            
                                    <p className="fontstyles titeles" style={{"cursor":"pointer"}}>
                                    {displayName(userStore.userData)}</p>
                            </div >
                            {
                                userModal && <UserModal setNavbar={setNavbar} setUserModal={setUserModal}/>
                            }

                    </div>   
                </div>
                {navbar === "profile" ? <Profile setNavbar={setNavbar} change={change} navbar={navbar}/> : 
                    pageSelection === "invite" ? 
                        <div className="flex mob-sidenav">
                                <SideNav setSelected={setSelected} searchInput={searchInput} setSearchInput={setSearchInput} groupChatOpened={groupChatOpened} closeMessagesModal={closeMessagesModal} setCloseMessagesModal={setCloseMessagesModal}/>
                        </div> : 
                        <div className="flex">
                            <General searchInput={searchInput} setSearchInput={setSearchInput} groupChatOpened={groupChatOpened} setGroupChatOpened={setGroupChatOpened} setNavbar={setNavbar} change={change} navbar={navbar} setPurpose={setPurpose} openModal={openModalPurpose} purpose={purpose} modalIsOpen={modalIsOpen} setIsOpen={setModalIsOpen}/>
                        </div>
                }
                {userStore.receivingCall ? (
                    <Modal
                        isOpen={isOpen}
                        isClose={closeModal}
                    >
                        <AnswerCall avatarImg={avatarImage} answerCall={answerCall} closeModal={closeModal} name={name}/>
                    </Modal>
                ) : null}
                {chatStore.user && <SingleChat />}
                <NotificationContainer />
            </div>
            <Modal isOpen={!!p2pRequest} isClose={declineP2PRequest}>
                {p2pRequest && (
                    <div style={{maxWidth: 360}} className="fontstyles">
                        <p style={{fontSize: 16, fontWeight: 600, marginBottom: 8}}>{p2pText.tr_incomingTitle}</p>
                        <p style={{marginBottom: 16}}>{p2pText.tr_incomingRequest(p2pRequest.fromName || p2pRequest.from)}</p>
                        <div style={{display: "flex", gap: 8, justifyContent: "flex-end"}}>
                            <button type="button" onClick={declineP2PRequest}
                                    className="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200">{p2pText.tr_decline}</button>
                            <button type="button" onClick={acceptP2PRequest}
                                    className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600">{p2pText.tr_accept}</button>
                        </div>
                    </div>
                )}
            </Modal>
        </>
    );
})

export default Home;
